<script setup>
import { computed } from "vue";
import { mdiTrendingDown, mdiTrendingUp, mdiTrendingNeutral } from "@mdi/js";
import CardBox from "@/Components/CardBox.vue";
import BaseLevel from "@/Components/BaseLevel.vue";
import PillTag from "@/Components/PillTag.vue";
//import UserAvatar from "@/Components/UserAvatar.vue";

const props = defineProps({
  label: {
    type: String,
    required: true,
  },
  cursos: {
    type: Array
  },
  curso: {
    type: Number,
    required: true,
  },
  date: {
    type: String,
    // - LRR required: true,
  },
  progress: {
    type: Number,
    default: 0,
  },
  text: {
    type: String,
    default: null,
  },
  type: {
    type: String,
    default: null,
  },
  // Otras notas
  asistencia: Number,
  participacion: Number,
  tarea: Number,
  conducta: Number,
  examen_parcial: Number,
  examen_parcial2: Number,
  examen_final: Number
});

const pillType = computed(() => {
  if (props.type) {
    return props.type;
  }

  if (props.progress) {
    if (props.progress >= 15) {
      return "success";
    }
    if (props.progress >= 11) {
      return "warning";
    }

    return "danger";
  }

  return "info";
});

const pillIcon = computed(() => {
  return {
    success: mdiTrendingUp,
    warning: mdiTrendingNeutral,
    danger: mdiTrendingDown,
    info: null,
  }[pillType.value];
});

const pillText = computed(() => props.text ?? `${props.progress}`);
</script>

<template>
  <CardBox class="mb-6 last:mb-0" is-hoverable>
    <BaseLevel>
      <BaseLevel type="justify-start">
        <!--<UserAvatar class="w-12 h-12 mr-6" :username="name" />-->
        <div class="text-center md:text-left overflow-hidden">
          <h4 class="text-xl text-ellipsis">
            {{ cursos.find(item => item.id === curso).label }}
          </h4>
          <p class="text-gray-500 dark:text-slate-400">
            <!--{{ date }} @ {{ login }}-->
            Promedio {{ label }} 
          </p>
        </div>
      </BaseLevel>
      <PillTag :color="pillType" :label="pillText" :icon="pillIcon" />
    </BaseLevel>
    <table>
      <thead>
        <tr>
          <th>Asistencia</th><th>Participacion</th><th>Tarea</th><th>Conducta</th><th>Examen_parcial</th><th>Examen_parcial2</th><th>Examen_final</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td data-label="Asistencia">{{ asistencia }}</td><td data-label="Participacion">{{ participacion }}</td><td data-label="Tarea">{{ tarea }}</td>
          <td data-label="Conducta">{{ conducta }}</td><td data-label="Examen_parcial">{{ examen_parcial }}</td><td  data-label="Examen_parcial2">{{ examen_parcial2 }}</td>
          <td data-label="Examen_final">{{ examen_final }}</td>
        </tr>
      </tbody>
    </table>
  </CardBox>
</template>
